import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";

function _setVal(value, antiQuillChange, antiTriggerChange) {
	u_.isString(value) || (value = "");
	Klass("VuwField").prototype.setVal.call(this, value);
	
	if(!antiQuillChange && this.quill) {
		if( !value || (/^{[\S\s]*}$/).test(value) ) {
			this.quill.setContents(!!value ? JSON.parse(value) : [{
				insert: "\n"
			}]);
			
		} else {
			this.quill.clipboard.dangerouslyPasteHTML(value);
			this._setVal(this.quill.getContents(), true);
		}
		
		if(value) {
			// pending untill all img is loaded.
			const imgList = u_.getAsArray( this.$editor.find("img:not([data-loaded])") );
			const methods = imgList.map(img => new Promise((resolve, reject) => {
				const $img = $(img);
				img.onload = () => {
					$img.attr("data-loaded", "1");
					resolve();
				};
				
				img.onerror = reject;
				
				img.complete && $img.trigger(!img.height ? "error" : "load", [true]);
			}));
			
			this._promise = new Promise(resolve => {
				const timer = setTimeout(resolve, 30000);
				Promise.all(methods).catch().then(() => {
					// always
					clearTimeout(timer);
					resolve();
				});
			});
		}
	}
	
	if(!antiTriggerChange) {
		!!this.$inp.length && this.$inp.val(value).trigger("change", [true]);
		!!this.$inpHTML.length && this.$inpHTML.val( this.getHtmlVal() );
	}
	
	return this;
}

export default _setVal;
